namespace $.$$ {
	export class $shm_paginator extends $.$shm_paginator {

		size() {
			const value = this.page_size()
			return Number.isFinite(value) ? Math.max(1, Math.floor(value)) : 50
		}

		count() {
			const value = this.total()
			return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0
		}

		pages() { return Math.max(1, Math.ceil(this.count() / this.size())) }

		current() {
			const value = this.page()
			return Number.isFinite(value) ? Math.max(0, Math.min(Math.floor(value), this.pages() - 1)) : 0
		}

		keys() {
			const count = this.pages(), current = this.current()
			if (count <= 7) return Array.from({length: count}, (_, index)=> String(index))
			const pages = new Set([0, count - 1])
			for (let index = current - 2; index <= current + 2; ++index) {
				if (index > 0 && index < count - 1) pages.add(index)
			}
			const ordered = [...pages].sort((a, b)=> a - b), keys: string[] = []
			for (const [index, page] of ordered.entries()) {
				if (index > 0 && page - ordered[index - 1] > 1) keys.push(`gap-${page}`)
				keys.push(String(page))
			}
			return keys
		}

		buttons() { return this.keys().map(key=> key.startsWith('gap-') ? this.Gap(key) : this.Button(key)) }
		button_title(key: string) { return String(Number(key) + 1) }
		button_current(key: string) { return Number(key) === this.current() ? 'page' : null }

		info() {
			const total = this.count(), start = this.current() * this.size() + 1
			return total ? `${start}–${Math.min(total, start + this.size() - 1)} из ${total}` : '0 результатов'
		}

		@ $mol_action
		pick(key: string, event?: Event) {
			if (event && /^\d+$/.test(key)) this.page(Math.max(0, Math.min(Number(key), this.pages() - 1)))
			return event ?? null
		}
	}
}
